import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} Krushnat Khavale. All rights reserved.</p>
    </footer>
  );
}

export default Footer;